"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
// eslint-disable-next-line max-lines-per-function
function SliderInteraction({ identifier, isPlusButtonActive, isActive, numberOfLayers, sliderWidth, onEvent, activeLayerIndex, resetButtonPressed, setResetButtonPressed, }) {
    const [performingPlus, setPerformingPlus] = (0, react_1.useState)(false);
    const [performingMinus, setPerformingMinus] = (0, react_1.useState)(false);
    const [currentIndex, setCurrentIndex] = (0, react_1.useState)(activeLayerIndex + 1);
    const minusRef = (0, react_1.useRef)(null);
    const plusRef = (0, react_1.useRef)(null);
    const defaultValue = activeLayerIndex + 1;
    const buttonRef = (0, react_1.useRef)(null);
    const onClickSlider = (value) => {
        if (typeof value !== 'number') {
            return;
        }
        setCurrentIndex(value);
        onEvent(identifier, bridge_schema_1.SystemsMenuAction.Slider, value - 1);
    };
    const onPlusEvent = (0, react_1.useCallback)((type) => {
        if (!isPlusButtonActive) {
            return;
        }
        switch (type) {
            case ui_1.ActionType.MOUSE_DOWN:
                setPerformingPlus(true);
                break;
            case ui_1.ActionType.SINGLE_CLICK:
            case ui_1.ActionType.DOUBLE_CLICK:
                onEvent(identifier, bridge_schema_1.SystemsMenuAction.Plus);
                setCurrentIndex(prevState => prevState + 1);
                break;
            case ui_1.ActionType.LONG_CLICK:
                onEvent(identifier, bridge_schema_1.SystemsMenuAction.LongPlus);
                setCurrentIndex(numberOfLayers);
                break;
            case ui_1.ActionType.MOUSE_UP:
                setPerformingPlus(false);
                break;
        }
    }, [isPlusButtonActive, onEvent, identifier, numberOfLayers]);
    const onMinusEvent = (0, react_1.useCallback)((type) => {
        if (!isActive) {
            return;
        }
        switch (type) {
            case ui_1.ActionType.MOUSE_DOWN:
                setPerformingMinus(true);
                break;
            case ui_1.ActionType.SINGLE_CLICK:
            case ui_1.ActionType.DOUBLE_CLICK:
                onEvent(identifier, bridge_schema_1.SystemsMenuAction.Minus);
                setCurrentIndex(prevState => prevState - 1);
                break;
            case ui_1.ActionType.LONG_CLICK:
                onEvent(identifier, bridge_schema_1.SystemsMenuAction.LongMinus);
                setCurrentIndex(0);
                break;
            case ui_1.ActionType.MOUSE_UP:
                setPerformingMinus(false);
                break;
        }
    }, [identifier, onEvent, isActive]);
    const [plusHandlers] = (0, ui_1.useLongPressHandlers)(onPlusEvent);
    const [minusHandlers] = (0, ui_1.useLongPressHandlers)(onMinusEvent);
    (0, react_1.useEffect)(() => {
        const handleKeyDown = (event) => {
            if (isActive &&
                document.activeElement === minusRef.current &&
                event.key === 'Enter') {
                onEvent(identifier, bridge_schema_1.SystemsMenuAction.Minus);
                setCurrentIndex(prevState => prevState - 1);
            }
            if (isPlusButtonActive &&
                document.activeElement === plusRef.current &&
                event.key === 'Enter') {
                onEvent(identifier, bridge_schema_1.SystemsMenuAction.Plus);
                setCurrentIndex(prevState => prevState + 1);
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [identifier, isActive, isPlusButtonActive, onEvent]);
    (0, react_1.useEffect)(() => {
        if (resetButtonPressed) {
            setCurrentIndex(defaultValue);
            setResetButtonPressed(!resetButtonPressed);
        }
    }, [resetButtonPressed, defaultValue, setResetButtonPressed]);
    return ((0, jsx_runtime_1.jsx)(Container, { ref: buttonRef, "$width": sliderWidth, "data-e2e": 'SliderInteraction_Container', children: (0, jsx_runtime_1.jsxs)(Controls, { "data-e2e": 'SliderInteraction_Controls', children: [(0, jsx_runtime_1.jsx)(ButtonContainer, { "data-e2e": 'SliderInteraction_ButtonContainer', children: (0, jsx_runtime_1.jsx)(ControlButton, Object.assign({ "$active": isActive, "$performingMouseDown": performingMinus, "data-testid": "system-minus-button" }, minusHandlers, { ref: minusRef, "data-e2e": 'SliderInteraction_ControlButton', children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: ui_1.Icons.Minus, height: 16, width: 16, "data-e2e": 'SliderInteraction_Icon' }) })) }), (0, jsx_runtime_1.jsx)(StyledSlider, { currentValue: currentIndex, max: numberOfLayers, onChange: onClickSlider, thumbClassName: "thumb", trackClassName: "track", markClassName: "mark", marks: true, "data-e2e": 'SliderInteraction_StyledSlider' }), (0, jsx_runtime_1.jsx)(ButtonContainer, { "data-e2e": 'SliderInteraction_ButtonContainer', children: (0, jsx_runtime_1.jsx)(ControlButton, Object.assign({ "$active": isPlusButtonActive, "$performingMouseDown": performingPlus, "data-testid": "system-plus-button" }, plusHandlers, { ref: plusRef, "data-e2e": 'SliderInteraction_ControlButton', children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: ui_1.Icons.Systems_Plus, height: 16, width: 16, "data-e2e": 'SliderInteraction_Icon' }) })) })] }) }));
}
exports.default = SliderInteraction;
const Container = styled_components_1.default.div `
  display: flex;
  justify-content: flex-start;
  box-sizing: border-box;
  width: ${({ $width }) => ($width ? `${$width}` : '256px')};
  height: 100%;

  text-align: center;

  user-select: none;

  ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
    padding: 16px 0px;
  `)};
`;
const Controls = styled_components_1.default.div `
  display: flex;
  left: 0;
  align-items: center;

  box-sizing: border-box;
  width: 100%;
`;
const ButtonContainer = styled_components_1.default.div `
  width: 60px;

  pointer-events: none;
`;
const ControlButton = styled_components_1.default.button `
  margin-top: 4px;

  transform: scale(
    ${({ $performingMouseDown }) => ($performingMouseDown ? 0.9 : 1)}
  );
  cursor: ${({ $active }) => ($active ? 'pointer' : 'initial')};
  opacity: ${({ $disabled }) => ($disabled ? 0.2 : 1)};

  color: ${({ theme, $active }) => $active ? theme.text : theme.textSecondary};

  border: 0;
  background-color: transparent;
  pointer-events: all;

  &:focus-visible {
    outline: none;
    border: 2px solid ${({ theme }) => theme.designSystem.accent};
  }
`;
const StyledSlider = (0, styled_components_1.default)(ui_1.Slider) `
  position: relative;
  width: 156px;

  ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
    width: 100%;
  `)};

  .track {
    height: 4px;
    background-color: ${({ theme }) => theme.grasshopper.systemMenus.line};
    margin: 0 10px 0 0;
  }

  .track-0 {
    background-color: ${({ theme }) => theme.grasshopper.systemMenus.lineFill};
    height: 6px;
  }

  .thumb {
    top: 50%;
    width: 20px;
    height: 20px;

    background-color: ${({ theme }) => theme.grasshopper.systemMenus.knob};
    border: 1px solid ${({ theme }) => theme.grasshopper.systemMenus.knobBorder};
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.5));
    transform: translate(-50%, -50%);
    z-index: 2 !important;
    margin: 0 calc(3px);
  }

  .thumb:focus {
    border: 2px solid ${({ theme }) => theme.designSystem.accent};
  }

  .mark {
    width: 2px;
    height: 2px;
    border: 0px;
    background-color: ${({ theme }) => theme.grasshopper.systemMenus.dot};
    border-radius: 50%;
    z-index: 1;
    margin: 0 calc(3px);
  }
`;
